class JPMCService {
  constructor() {
    this.data = this.data || jpmcDataFeed;
  }
  getConfig() {
    return this.data.config;
  }
  getJobFamilyById(id) {
    return this.data.jobFamilies.find((family) => {
      return family.id === id;
    });
  }
  getAllJobs() {
    let career = [];
    for (let family of this.data.jobFamilies) {
      for (let job of family.jobs) {
        job.familyName = family.name;
        job.familyUrl = family.url || '#';
        career.push(job);
      }
    }
    return career;
  }
  getJobById(id) {
    for (let family of this.data.jobFamilies) {
      for (let job of family.jobs) {
        if (job.id === id) {
          return job;
        }
      }
    }
  }
  getEducators() {
    let educators = [];
    for (let educator of this.data.educators) {
      for (let location of educator.educatorLocations) {
        location.title = educator.title;
        location.url = educator.url;
        location.siteUrl = educator.siteUrl;
        educators.push(location);
      }
    }
    return educators;
  }
  getEmployers() {
    let employers = [];
    for (let employer of this.data.employers) {
      for (let location of employer.employerLocations) {
        location.title = employer.title;
        location.url = employer.url;
        location.siteUrl = employer.siteUrl;
        employers.push(location);
      }
    }
    return employers;
  }
}

export default JPMCService;



// WEBPACK FOOTER //
// ./src/services/jpmc.service.js